module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/12fffb88cc245027ce8ab2c020be8318.png";